import { getQaStore } from '@/sub-luca-plugin/store/qa';
import sensors from 'sa-sdk-javascript';

const sensorsInit = () => {
    try {
        sensors.init({
            server_url: 'https://gaodun.datasink.sensorsdata.cn/sa?project=default&token=b9ea8de774df405c',
            name: 'sa',
            show_log: false,
            send_type: 'image',
            heatmap: {
                clickmap: 'default',
                scroll_notice_map: 'default',
            },
        });
    } catch (error) {
        console.log('sensors_init_error', error);
    }
};

const report = (name: string, params: Record<string, any>) => {
    try {
        sensors.track(name, { ...params, luca_client_source: 'PC' });
    } catch (error) {
        console.log('sensors_report_error', error);
    }
};

// 每次创建学科搜索卡片时触发
export const createSubjectSearchCardSensors = ({
    qaNum,
    videoNum,
    knowledgePointsNum,
    recordId,
    lucaAskChatId,
}: {
    qaNum: number;
    videoNum: number;
    knowledgePointsNum: number;
    recordId: string;
    lucaAskChatId: string;
}) => {
    const { projectId, subjectId, twoLevelSubjectId, aiTag } = getQaStore()!.qaConfig;
    // console.log('创建学科搜索卡片-埋点');
    report('create_subject_search_card', {
        project_id: projectId,
        subject_id: subjectId,
        two_subject_id: twoLevelSubjectId,
        is_AI: Boolean(aiTag),
        Qa_number: qaNum,
        video_number: videoNum,
        knowledge_number: knowledgePointsNum,
        luca_ask_chat_id: lucaAskChatId,
        record_id: recordId,
    });
};

// 每次点击学科搜索卡片内容（qa数据、知识点切片）时触发
export const clickSubjectSearchDataSensors = ({
    dataType,
    havePermission,
    recordId,
}: {
    dataType: 'QA' | '视频' | '知识点';
    havePermission: boolean;
    recordId: string;
}) => {
    const { projectId, subjectId, twoLevelSubjectId, aiTag, lucaAskChatId } = getQaStore()!.qaConfig;
    // console.log('点击学科搜索数据-埋点');
    report('click_subject_search_data', {
        project_id: projectId,
        subject_id: subjectId,
        two_subject_id: twoLevelSubjectId,
        is_AI: Boolean(aiTag),
        is_permission: havePermission,
        data_type: dataType,
        luca_ask_chat_id: lucaAskChatId,
        record_id: recordId,
    });
};

// 每次以学科搜索模式，发送消息时触发
export const clickSubjectSearchButtonSensors = ({ lucaAskChatId }: { lucaAskChatId: string }) => {
    const { projectId, subjectId, twoLevelSubjectId } = getQaStore()!.qaConfig;
    // console.log('点击学科搜索按钮发送-埋点');
    report('click_subject_search_button_send', {
        project_id: projectId,
        subject_id: subjectId,
        two_subject_id: twoLevelSubjectId,
        luca_ask_chat_id: lucaAskChatId,
    });
};

export default sensorsInit;
